import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import AssignedPublicationListItem from './AssignedPublicationListItem'
import useAssignedPublications from './hooks/useAssignedPublications'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Publication Title',
    },
  ]
}

const AssignedPublications = (props) => {
  const { serviceProductPayload } = props
  const {
    callbacks: {
      manageServiceProductPublications,
      togglePublication,
    },
    loading,
    serviceProduct,
  } = serviceProductPayload

  const filterPayload = useFilters()
  const { pageFilters } = filterPayload

  const {
    filteredPublications,
    hasAssignedPublications,
    hasFilteredPublications,
  } = useAssignedPublications(serviceProduct, pageFilters)

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-assigned-publications' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={hasAssignedPublications && <DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Assigned Publications"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredPublications && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Assigned Publications present.
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please adjust your filters or assign a Publication.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredPublications && (
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredPublications.map(publication => (
              <AssignedPublicationListItem
                callbacks={{
                  togglePublication: () => togglePublication(publication.id, 'publication'),
                }}
                key={publication.id}
                publication={publication}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => manageServiceProductPublications({ optionsKey: 'publication' })}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Publication
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

AssignedPublications.propTypes = {
  serviceProductPayload: PropTypes.object.isRequired,
}

export default AssignedPublications
